import { Component, Input,  } from '@angular/core';

import { Driver } from '../../../../commons/models/domain/Driver';

import {NewNavigationService} from "@shared/services/new-navigation.service";
import { StringService } from '@shared/services/string.service';

import {WorkerService} from "@layout/driver/services/worker.service";

@Component({
    selector: 'wm-driver-details-header',
    templateUrl: './driver-details-header.component.html'
})
export class DriverDetailsHeaderComponent   {

    @Input() public driver?: Driver;

    get fullName(): string {
      return this.stringService.truncate(this.driver?.FN + ' ' + this.driver?.LN);
    }

    constructor(
      private newNavigationService: NewNavigationService,
      private stringService: StringService,
      private workerService: WorkerService,
    ) {
    }

  onClose() {
      this.workerService.workerDetailsPanelClosedSub$.next(true);
    this.newNavigationService.toWorkersList();
  }
}
